module.exports = __webpack_public_path__ + "static/media/white-news.94cb98b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/white-news.svg
// module id = 308
// module chunks = 0